import script from "./CardObjectivesLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./CardObjectivesLoader.vue?vue&type=script&setup=true&lang=js"

import "./CardObjectivesLoader.vue?vue&type=style&index=0&id=9e178f6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e178f6c"]])

export default __exports__